import { collapseLeftSidebar } from "../inference/inference.js";

// Add a new object to store processing times for different models and file sizes
const processingTimeHistory = {
    teethml: [],
    defectml: [],
    keypointml: [],
    teethseparation: [],
    arrangement: []
};

// Function to estimate processing time based on model type only, ignoring file size
function estimateProcessingTime(fileSize, modelType) {
    // Default estimates if no history
    const defaultEstimates = {
        teethml: 40, // seconds
        defectml: 10, // seconds
        keypointml: 15, // seconds
        teethseparation: 160, // seconds
        arrangement: 30 // seconds
    };

    // If we have history for this model type, calculate average processing time
    if (processingTimeHistory[modelType].length > 0) {
        const relevantHistory = processingTimeHistory[modelType];
        // Get the most recent entries (up to 5)
        const recentEntries = relevantHistory.slice(-5);

        // Calculate simple average of processing times
        let totalTime = 0;
        recentEntries.forEach((entry) => {
            totalTime += entry.timeInSeconds;
        });

        return Math.round(totalTime / recentEntries.length);
    }

    // Return default estimate if no relevant history
    return defaultEstimates[modelType];
}

// Function to update the progress bar
function updateProgressBar(percent, timeRemaining) {
    const processingIndicator = document.getElementById("processing-indicator");
    const progressBar = document.querySelector(
        "#processing-indicator .progress-bar"
    );
    const progressPercent = document.querySelector(
        "#processing-indicator .progress-percent"
    );
    const progressTime = document.querySelector(
        "#processing-indicator .progress-time"
    );

    // Force proper positioning
    processingIndicator.style.position = "fixed";
    processingIndicator.style.bottom = "0";
    processingIndicator.style.top = "auto";
    processingIndicator.style.left = "0";
    processingIndicator.style.width = "100%";
    processingIndicator.style.zIndex = "9999";

    // Make sure the indicator is visible
    processingIndicator.style.display = "block";

    // Update progress bar width
    progressBar.style.width = `${percent}%`;
    progressPercent.textContent = `${Math.round(percent)}%`;

    if (timeRemaining !== undefined) {
        // Check if timeRemaining is a string (for "Almost done here...")
        if (typeof timeRemaining === "string") {
            progressTime.textContent = timeRemaining;
        }
    }

    // Auto-collapse sidebar when processing starts
    if (percent <= 10) {
        collapseLeftSidebar();
    }

    // Processing complete - sidebar remains in its current state
}

export { processingTimeHistory, estimateProcessingTime, updateProgressBar };
